var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 555,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-240 -86)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.312 109.448C455.675 109.448 460.833 114.606 460.833 120.969L460.833 351.385C460.833 357.748 455.675 362.906 449.312 362.906L380.188 362.906 380.188 427.262 322.088 369.162 318.712 365.786 103.688 365.786C97.3245 365.786 92.1667 360.629 92.1667 354.266L92.1667 120.969C92.1667 114.606 97.3245 109.448 103.688 109.448L449.312 109.448M449.312 97.9271 103.688 97.9271C90.9622 97.9271 80.6458 108.243 80.6458 120.969L80.6458 354.266C80.6458 366.991 90.9622 377.307 103.688 377.307L313.943 377.307 391.708 455.073 391.708 374.427 449.312 374.427C462.038 374.427 472.354 364.111 472.354 351.385L472.354 120.969C472.354 108.243 462.038 97.9271 449.312 97.9271Z",
    stroke: "#1866FE",
    strokeWidth: 5.76042,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    fill: "#1866FE",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00181 240 87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.948 236.177C385.948 245.721 378.211 253.458 368.667 253.458 359.122 253.458 351.385 245.721 351.385 236.177 351.385 226.633 359.122 218.896 368.667 218.896 378.211 218.896 385.948 226.633 385.948 236.177Z",
    stroke: "#1866FE",
    strokeWidth: 5.76042,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    fill: "#1866FE",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00181 240 87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.781 236.177C293.781 245.721 286.044 253.458 276.5 253.458 266.956 253.458 259.219 245.721 259.219 236.177 259.219 226.633 266.956 218.896 276.5 218.896 286.044 218.896 293.781 226.633 293.781 236.177Z",
    stroke: "#1866FE",
    strokeWidth: 5.76042,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    fill: "#1866FE",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00181 240 87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.615 236.177C201.615 245.721 193.877 253.458 184.333 253.458 174.789 253.458 167.052 245.721 167.052 236.177 167.052 226.633 174.789 218.896 184.333 218.896 193.877 218.896 201.615 226.633 201.615 236.177Z",
    stroke: "#1866FE",
    strokeWidth: 5.76042,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    fill: "#1866FE",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00181 240 87)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.f8c07a9a5e5f40341d5049ac09aa0167.svg";
export { ForwardRef as ReactComponent };